export class NecLeftNav {
  name: string;
  link: string;
  active: boolean;
  children?: NecLeftNav[];
}
